import { defineAction } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'
import semenStockReportAction from './semenStockReport.action.json' with { type: 'json' }
import { semenStockReportTypeSchema } from './semenStockReportShared'

const semenStockReportDefinition = defineAction({
  ...semenStockReportAction,

  input: z.object({
    format: reportFormatSchema,
    reportType: semenStockReportTypeSchema,
    referenceMonth: dateOrIsoString().nullish(),
  }),
  output: z.any(),
})

export default semenStockReportDefinition
